import store from '@/store';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import { calculateAge, LocalDateTimeToText, LocalDateToText } from '@/common/utils/module/FormattingSupport';
import { nativeShareText } from '@/common/utils/module/NativeRequest';
import { showTextModal } from '@/common/utils/ModalState';
import { getCurrentPath, isIPad, isIPhone, isSafari } from '@/common/utils/Util';

/**
 * 부고장 공유하기
 */
export const announcementShare = () => {
  const announcement = store.getters['announcement/getDetail']; // 부고장 정보
  // const deathDate = LocalDateToText(announcement.deathDate); // 소천일

  // const location = `${announcement.address} ${announcement?.funeralName} ${announcement?.funeralRoom}`; // 빈소
  // const carryDate = LocalDateToText(announcement.carryDate); // 발인일
  // let burialSite = '';
  // burialSite = announcement?.burialSite ? `\n장지 : ${announcement?.burialSite} \n` : ''; // 장지
  // getCurrentPath(); // 현재 경로 링크

  const form = `[Life END Life] ${announcement.deadName}님의 장례식(장소)를 알려드립니다.\n링크 : 
  ${CODE_ENV_LIST.DYNAMIC_DOMAIN}/${getCurrentPath()}`;

  nativeShareText(form);
  navigator.clipboard.writeText(form).then(() => {
    if (!isIPhone() && !isIPad()) {
      showTextModal('현재 부고장 내용이 복사되었습니다.', '확인');
    }
  });
};

/**
 * 카카오 공유하기
 */
export const announcementKakaoShare = () => {
  const announcement = store.getters['announcement/getDetail']; // 부고장 정보

  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `${announcement.deadName}님의 장례식(장소)를 알려드립니다.`,
      imageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/backgroundImage/flower/05.jpg`,
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/announcement/${announcement.announcementNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/announcement/${announcement.announcementNo}`
      }
    },
    itemContent: {
      profileText: 'Life END Life',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/announcement/${announcement.announcementNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/announcement/${announcement.announcementNo}`
        }
      }
    ]
  });
};
